export default __webpack_public_path__ + "static/media/course-preview-default-img.22d47bd8.svg";